<template>
  <tr :class="{ collapsed, main: true, odd: isOdd }">
    <td :style="`padding-bottom: ${tdPaddingBottom()}`">
      <a href="#" @click.stop.prevent="handleToggleDetails">
        <span :class="`icon-caret-${collapsed ? 'down' : 'up'} toggle-icon`"></span>
      </a>
    </td>
    <td :style="`padding-bottom: ${tdPaddingBottom()}`">
      <a href="#" class="product-name-link" @click.stop.prevent="handleToggleDetails">
        {{ item.productName }}
      </a>
      <br>
      <div class="line-item-details">
        <span>
          <b>{{ $t('purchased') }}:</b> {{ getReadableDate(item.purchasedDate) }}
          <b>{{ $tc('expiring', 2) }}:</b> {{ getReadableDate(item.expirationDate) }}
        </span>
      </div>
      <div class="line-item-content" :style="`display: ${collapsed ? 'none' : 'block'}`">
        <div class="col-12">
          <div class="col-12">
            <table class="list-item-table" ref="listItemTable">
              <thead>
                <tr>
                  <th>{{ $t('name') }}</th>
                  <th>
                    <b-select
                      class="all-assets-child-dynamic-column-select"
                      v-model="dynamicColumnOption"
                      @change="handleDynamicColumnOptionChange"
                      :options="dynamicColumnOptions"
                    />
                  </th>
                  <th>{{ $t('quantity') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in childItems" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td>{{ item[dynamicColumnOption] }}</td>
                  <td style="text-align: right;">{{ item.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </td>
    <td :style="`padding-bottom: ${tdPaddingBottom()}`">{{ item[dynamicKey] }}</td>
    <td :style="`padding-bottom: ${tdPaddingBottom()}`">{{ item.quantity }}</td>
  </tr>
</template>

<script>
import moment from 'moment'

import DateFormatMixin from '../mixins/DateFormatMixin'

export default {
  name: 'AllAssetsListItem',
  mixins: [DateFormatMixin],
  data () {
    return {
      collapsed: true,
      listItemTableHeight: null,
      dynamicColumnOption: 'lineItemNumber',
      dynamicColumnOptions: [
        { value: 'laCode', text: this.$t('licenseAccessCode') },
        { value: 'lineItemNumber', text: `${this.$tc('orderNumber', 2)}/${this.$t('lineItemNumber')}` }
      ]
    }
  },
  props: {
    item: { type: Object, required: true },
    dynamicKey: { type: String, default: 'orderNumber' },
    isOdd: { type: Boolean, required: true }
  },
  computed: {
    childItems () {
      return this.item.list.sort((a, b) => Number(a.lineItemNumber) - Number(b.lineItemNumber))
    }
  },
  methods: {
    tdPaddingBottom () {
      if (this.collapsed) return '12px;'
      return `${this.listItemTableHeight + 50}px;`
    },
    handleToggleDetails () {
      this.collapsed = !this.collapsed
      this.$nextTick(() => {
        this.updateTdPadding()
      })
    },
    updateTdPadding () {
      this.listItemTableHeight = !this.collapsed ? this.$refs.listItemTable.clientHeight : null
    },
    getReadableDate (date) {
      if (!date) return 'N/A'
      if (+moment(date).format('YYYY').includes('1752')) return 'N/A'
      const temp = moment(date).format(this.getDateFormatBasedOnLocale())
      return (temp.includes('0001')) || (temp.includes('1752')) ? 'N/A' : temp
    },
    handleDynamicColumnOptionChange (dynamicColumnOption) {
      this.dynamicColumnOption = dynamicColumnOption
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  a,
  a:hover {
    color: $primary;
  }

  .list-item-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 0.2rem;
  }

  .list-item-table thead th {
    background: $darkGray;
    border-color: $darkGray;
    color: $white;
    font-weight: 400;
    padding: 8px 12px;
  }

  .list-item-table thead th:first-child,
  .list-item-table tbody td:first-child {
    width: 60%;
    border-right: 1px solid #dee2e6;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .list-item-table thead th:nth-child(2),
  .list-item-table tbody td:nth-child(2) {
    width: 30%;
    display: none;
  }

  .list-item-table thead th:last-child,
  .list-item-table tbody td:last-child {
    width: 10%;
    display: none;
  }

  .list-item-table tbody td {
    padding: 8px 12px;
  }

  tr.main {
    position: relative;
    background: $white;
  }

  tr.main.odd {
    background: $lightPrimary;
  }

  .list-item-table tr {
    background: $lightPrimary;
  }

  tr.main.odd .list-item-table tr {
    background: $white;
  }

  tr.main > td:first-child {
    width: 5%;
    vertical-align: middle;
  }

  .toggle-icon {
    color: $primary;
    font-size: 20px;
  }

  tr.main > td:nth-child(2) {
    width: 55%;
    border-right: 1px solid #dee2e6;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    vertical-align: top;
  }

  .product-name-link,
  .product-name-link:hover {
    color: $primary;
  }

  .line-item-details {
    font-size: 0.8rem;
  }

  .line-item-content {
    position: absolute;
    left: 0;
    right: 0;
    margin-top: 15px;
  }

  tr.main > td:nth-child(3) {
    width: 30%;
    vertical-align: top;
    display: none;
  }

  tr.main > td:last-child {
    width: 10%;
    vertical-align: top;
    text-align: right;
    display: none;
  }

  tr.main.collapsed > td {
    padding: 12px 12px 20px;
  }

  tr.main > td {
    padding: 12px 12px;
  }

  .inner-pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
  }

  .all-assets-child-dynamic-column-select,
  .all-assets-child-dynamic-column-select:active,
  .all-assets-child-dynamic-column-select:hover,
  .all-assets-child-dynamic-column-select:focus {
    background: $darkGray;
    color: $white;
    border: 1px solid #5d6166 !important;
    box-shadow: 2px 2px #5d6166, 2px 2px #5d6166;
    text-indent: 0;
    -webkit-appearance: menulist;
    margin-left: -15px;
  }

  @media (min-width: 768px) {
    .options-container {
      height: auto;
      opacity: 1;
    }
    .page-size-col {
      max-width: 120px;
      flex: 0 0 120px;
    }
    tr.main td:nth-child(2) {
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    tr.main td:nth-child(3) {
      display: table-cell;
    }
    tr.main td:last-child {
      display: table-cell;
    }
    .list-item-table thead th:first-child,
    .list-item-table tbody td:first-child {
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .list-item-table thead th:nth-child(2),
    .list-item-table tbody td:nth-child(2) {
      display: table-cell;
    }

    .list-item-table thead th:last-child,
    .list-item-table tbody td:last-child {
      display: table-cell;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AllAssetsListItem.vue